<template> 
  <div class="base-timer">
    <svg class="base-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <g class="base-timer__circle">
        <circle class="base-timer__path-elapsed" cx="50" cy="50" r="45"></circle>
        <path :stroke-dasharray="circleDasharray" class="base-timer__path-remaining" :class="remainingPathColor" d="
            M 50, 50
            m -45, 0
            a 45,45 0 1,0 90,0
            a 45,45 0 1,0 -90,0
          "></path>
      </g>
    </svg>
    <span class="base-timer__label">{{ formattedTimeLeft }}</span>
  </div>
      <!-- <input  type="button" @click="start" value="Start" />
      <input type="button"  @click="pauseTimer" value="Pause" />
      <input type="button"  @click="resumeTimer" value="Resume" /> -->




</template>

<script>
// // import axios from 'axios';
import { useStore } from 'vuex'
import { useToast } from 'vue-toastification';

const FULL_DASH_ARRAY = 283;
const WARNING_THRESHOLD = 35;
const ALERT_THRESHOLD = 10;

const COLOR_CODES = {
  info: {
    color: '#071D49'
  },
  warning: {
    color: "orange",
    threshold: WARNING_THRESHOLD
  },
  alert: {
    color: "red",
    threshold: ALERT_THRESHOLD
  }
};

const TIME_LIMIT = 4200;  //Tiempo en segundos
export default {
  data() {
    return {
      message: "",
      timePassed: 0,
      timerInterval: null,
      i: null,
      contador: 0,
    };
  },
  setup() {
    const store = useStore();
    const toast = useToast();
    return { store, toast };
  },
  computed: {
    circleDasharray() {
      return `${(this.timeFraction * FULL_DASH_ARRAY).toFixed(0)} 283`;
    },

    formattedTimeLeft() {
      const timeLeft = this.timeLeft;
      const minutes = Math.floor(timeLeft / 60);
      let seconds = timeLeft % 60;
       let firstNoti = this.$store.state.notifi; //minuto de la primera notificación
      // let numNotifi = this.$store.state.numNotifi; //número de notificaciones a mostrar
      // let intervalNotifi = this.$store.state.intervalNotifi; //intervalo de tiempo de las notificaciones

       if (minutes == firstNoti && seconds == 0 ) {        
          this.myMethod();
       }
      
  
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      if (seconds == 0 && minutes == 0) {
        clearInterval(this.alertasTiempo);
        stop(this.alertasTiempo);
        this.$store.commit('setBtnFinalizar', 2)
        this.$store.commit('setInicioExmen', 2)
        // this.myMethod2();
      }
      

      return `${minutes}:${seconds}`;

    },

    timeLeft() {
      return TIME_LIMIT - this.timePassed;
    },

    timeFraction() {
      const rawTimeFraction = this.timeLeft / TIME_LIMIT;
      return rawTimeFraction - (1 / TIME_LIMIT) * (1 - rawTimeFraction);
    },

    remainingPathColor() {
      const { alert, warning, info } = COLOR_CODES;
      const time = Math.floor(this.timeLeft / 60)

      if (time <= alert.threshold) {
        return alert.color;
      } else if (time <= warning.threshold) {
        return warning.color;
      } else {
        return info.color;
      }
    }
  },

  watch: {
    timeLeft(newValue) {
      if (newValue === 0) {
        this.onTimesUp();
        // this.$router.push('/Fin-Examen')
      }
      if (this.store.state.btnFinalizar === 3) {
        this.onTimesUp();
      }
    }
  },

  mounted() {
      this.start();
  },

  methods: {

    myMethod() {
      this.toast("Atención le quedan " + this.$store.state.notifi + " minutos de la prueba. \n "    + this.$store.state.messageParametros, 
      {
        timeout: 5000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
        closeOnClick: false

      });
    },
    myMethod2() {
      this.toast("Se ha agotado el tiempo,\n su prueba ha finalizado ", 
      {
        timeout: 5000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
        closeOnClick: false

      });
    },

    onTimesUp() {
      clearInterval(this.timerInterval);
    },

    start() {
     this.timerInterval = setInterval(() => (this.timePassed += 1), 1000);
    },

    pauseTimer(){
      clearInterval(this.timerInterval);
    },
    resumeTimer() {
      this.startTimer();
    },

    alertasTiempo() {
      var interval = 1000 * this.$store.state.divisionNoti
      console.log(interval)
      setInterval(function () {
        console.log("Atención le quedan 20 minutos de la prueba");
      }, interval)
    },
  }
};
</script>

<style scoped lang="scss">
.base-timer {
  position: relative;
  height: 135px;
  justify-content: center;
  display: flex;


  &__svg {
    transform: scaleX(-1);
  }

  &__circle {
    fill: none;
    stroke: none;
  }

  &__path-elapsed {
    stroke-width: 7px;
    stroke: grey;
  }

  &__path-remaining {
    stroke-width: 7px;
    stroke-linecap: round;
    transform: rotate(90deg);
    transform-origin: center;
    transition: 1s linear all;
    fill-rule: nonzero;
    stroke: currentColor;

    &.green {
      color: rgb(65, 184, 131);
    }

    &.orange {
      color: orange;
    }

    &.red {
      color: red;
    }
  }

  &__label {
    position: absolute;
    width: 135px;
    height: 135px;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 40px;
  }
}
</style>
